import type {ComponentProps, FC} from 'react';

import {Heading} from '@/modules/foundation/components/typography/heading';
import type {CommerceProductSize} from '@/sanity/schemas/types';

import {RadioTile} from '../form/RadioTile';

import type {ProductSizeConfiguration} from './configuration';

export type ProductColorSelectorProps = ComponentProps<'fieldset'> & {
	sizes: CommerceProductSize[];
	namePrefix?: string;
	defaultConfiguration: ProductSizeConfiguration | null;
	legend?: string;
};

export const ProductSizeSelector: FC<ProductColorSelectorProps> = ({
	sizes,
	namePrefix,
	defaultConfiguration,
	legend,
	...rest
}) => {
	const sizesById = sizes.reduce((acc, size) => {
		if (size) {
			acc.set(size._id, size);
		}

		return acc;
	}, new Map<string, CommerceProductSize>());

	const uniqueSizes = sizesById ? Array.from(sizesById.values()) : [];

	return (
		<fieldset {...rest}>
			{legend && (
				<Heading size="h3" asChild className="mb-3">
					<legend>{legend}</legend>
				</Heading>
			)}
			<div className="flex flex-wrap gap-2">
				{uniqueSizes.map((size) => (
					<RadioTile
						key={size._id}
						value={size._id}
						name={namePrefix}
						defaultChecked={defaultConfiguration === size._id}
					>
						{size.name}
					</RadioTile>
				))}
			</div>
		</fieldset>
	);
};
